// Action Types
export const FETCH_COMPETENCY_ASSESSMENT_REQUEST = 'FETCH_COMPETENCY_ASSESSMENT_REQUEST';
export const FETCH_COMPETENCY_ASSESSMENT_SUCCESS = 'FETCH_COMPETENCY_ASSESSMENT_SUCCESS';
export const FETCH_COMPETENCY_ASSESSMENT_FAILURE = 'FETCH_COMPETENCY_ASSESSMENT_FAILURE';
export const UPDATE_COMPETENCY_ASSESSMENT_FROM_SOCKET = 'UPDATE_COMPETENCY_ASSESSMENT_FROM_SOCKET';
export const SET_COMPETENCY_ACCESS_BLOCKED = 'SET_COMPETENCY_ACCESS_BLOCKED';
export const CONNECT_COMPETENCY_WEBSOCKET = 'CONNECT_COMPETENCY_WEBSOCKET';
export const DISCONNECT_COMPETENCY_WEBSOCKET = 'DISCONNECT_COMPETENCY_WEBSOCKET';
export const SET_COMPETENCY_WEBSOCKET_STATUS = 'SET_COMPETENCY_WEBSOCKET_STATUS';
export const FETCH_COMPETENCY_ASSESSMENT_IS_NATURAL_USER_TYPE_SUCCESS = 'FETCH_COMPETENCY_ASSESSMENT_IS_NATURAL_USER_TYPE_SUCCESS';

// Action Creators
export const fetchCompetencyAssessmentRequest = () => ({
  type: FETCH_COMPETENCY_ASSESSMENT_REQUEST,
});

export const fetchCompetencyAssessmentSuccess = (data: any) => ({
  type: FETCH_COMPETENCY_ASSESSMENT_SUCCESS,
  payload: data,
});

export const fetchCompetencyAssessmentFailure = (error: any) => ({
  type: FETCH_COMPETENCY_ASSESSMENT_FAILURE,
  payload: error,
});

export const updateCompetencyAssessmentFromSocket = (data: any) => ({
  type: UPDATE_COMPETENCY_ASSESSMENT_FROM_SOCKET,
  payload: data,
});

export const setCompetencyAccessBlocked = (blocked: boolean) => ({
  type: SET_COMPETENCY_ACCESS_BLOCKED,
  payload: blocked,
});

export const connectCompetencyWebSocket = (userId: string) => ({
  type: CONNECT_COMPETENCY_WEBSOCKET,
  payload: userId,
});

export const disconnectCompetencyWebSocket = () => ({
  type: DISCONNECT_COMPETENCY_WEBSOCKET,
});

export const setCompetencyWebSocketStatus = (connected: boolean) => ({
  type: SET_COMPETENCY_WEBSOCKET_STATUS,
  payload: connected,
});


export const fetchCompetencyAssessmentIsNaturalUserTypeSuccess = (data: any) => ({
  type: FETCH_COMPETENCY_ASSESSMENT_IS_NATURAL_USER_TYPE_SUCCESS,
  payload: data,
});
